<template>
  <div class="animated fadeIn">
    <profile-buttons v-if="userStatus.emailConfirmed && userStatus.phoneNumberConfirmed"/>
    
    <!-- <div class="text-center">
      <img class="d-block mx-auto mb-4" src="/img/logo-symbol.png" />
      <h2 class="my-4">{{$t('dashboard.welcome')}}</h2>
      <p class="card-text">{{$t('dashboard.welcomeToYourDashboard')}}</p>
    </div> -->
  </div>
</template>

<script>
import Breadcrumb from '@/mixins/breadcrumb'
import ProfileButtons from '@/components/account/profile/ProfileButtons'

export default {
  name: 'Dashboard',
  components: {
    ProfileButtons
  },
  mixins: [Breadcrumb],
  computed: {
    userStatus () {
      return this.$store.state.$userStatus
    }
  },
  mounted () {
    this.setBreadcrumb()
  },
  methods: {
    setBreadcrumb () {
      const items = []
      let path = ''

      path += '/dashboard'
      items.push({ path, text: this.$t('nav.dashboard') })

      this.commitBreadcrumb(items)
    }
  }
}
</script>
